// This class is used to gather and construct instance tree data in the property worker.
// We cannot use LMV imports in workers, so this is a (slightly modified) copy of the LMV class.

import { FlatStringStorage } from "./FlatStringStorage";

/* struct Node {
	int dbId;
	int parentDbId;
	int firstChild; // if negative it's a fragment list
	int numChildren;
	int flags;
	int level;
};
sizeof(Node) == 24 */

export const SIZEOF_NODE = 6; //integers
export const OFFSET_DBID = 0;
export const OFFSET_PARENT = 1;
export const OFFSET_FIRST_CHILD = 2;
export const OFFSET_NUM_CHILD = 3;
export const OFFSET_FLAGS = 4;
export const OFFSET_LEVEL = 5;

function arrayToBuffer(a) {
  if (a instanceof Int32Array) {
    return a;
  }

  var b = new Int32Array(a.length);
  b.set(a);
  return b;
}

export class InstanceTreeStorage {
  constructor() {
    this.nodes = [];
    this.nextNode = 0;

    this.children = [];
    this.nextChild = 0;

    this.dbIdToIndex = {};

    this.strings = new FlatStringStorage();
    this.nameSuffixes = []; // DT: Unused, but required for LMV's InstanceTreeAccess class

    //Occupy index zero so that we can use index 0 as undefined
    this.getIndex(0);
  }

  getIndex(dbId) {
    var index = this.dbIdToIndex[dbId];

    if (index)
    return index;

    index = this.nextNode++;

    //Allocate space for new node
    this.nodes.push(dbId); //store the dbId as first integer in the Node structure
    //Add four blank integers to be filled by setNode
    for (var i = 1; i < SIZEOF_NODE; i++)
    this.nodes.push(0);

    this.dbIdToIndex[dbId] = index;

    return index;
  }

  setNode(dbId, parentDbId, name, flags, childrenIds, fragIds, level = 0) {
    var index = this.getIndex(dbId);

    var baseOffset = index * SIZEOF_NODE;

    var numChildren = childrenIds.length;
    var hasFragments = fragIds && fragIds.length;
    if (hasFragments) {
      numChildren += fragIds.length;
    }

    this.nodes[baseOffset + OFFSET_PARENT] = parentDbId;
    this.nodes[baseOffset + OFFSET_FIRST_CHILD] = this.nextChild;
    this.nodes[baseOffset + OFFSET_NUM_CHILD] = hasFragments ? -numChildren : numChildren;
    this.nodes[baseOffset + OFFSET_FLAGS] = flags;
    this.nodes[baseOffset + OFFSET_LEVEL] = level;

    var i;
    for (i = 0; i < childrenIds.length; i++)
    this.children[this.nextChild++] = this.getIndex(childrenIds[i]);

    //Store fragIds as negative numbers so we can differentiate them when looking through
    //the array later.
    if (hasFragments) {
      for (i = 0; i < fragIds.length; i++)
      this.children[this.nextChild++] = -fragIds[i] - 1; //index 0 stored as -1, etc., since 0 is not negative
    }

    if (this.nextChild > this.children.length) {
      // TODO: this code may run in a worker, replace console with something else
      console.error("Child index out of bounds -- should not happen");
    }

    // DT: Tandem does not generally need to decompose elements names,
    // because they are expected to be already, so we store the complete name.
    if (name !== undefined) {
      this.setNodeName(dbId, name);
    }
  }

  setNodeName(dbId, name) {
    var index = this.getIndex(dbId);
    this.strings.add(name, index);
  }

  flatten() {
    this.nodes = arrayToBuffer(this.nodes);
    this.children = arrayToBuffer(this.children);
    this.strings.flatten();
  }
}